import React from 'react'
import styled from "styled-components"

import { Link as InternalLink } from "gatsby"

import { typeHeading02, typeHeading04, typeBody01, typeLabel01 } from '../../theme/typography'
import { grid, row, column } from '../../theme/grid'
import { spacer, unit, pixelate, margin, SIZE, mediaQuery } from '../../theme/metrics'
import { WHITE_01 } from '../../theme/colors'

import { button } from '../../theme/core';

import { StyledLinks } from '../../theme/components'


export const TextContainer = styled.div`
	${props => column({medium:{span:4,before:1,after:1}},{direction:props.theme.direction})}
	padding-top: ${spacer(1)};

	${mediaQuery[SIZE.medium]}{
		padding-top: 0;
	}
`

export const Text = styled.div`
	${typeBody01}
	color: ${props => props.theme.foreground};
	
`

export const ImageContent = styled.div`
	width: 100%;
	position: relative;
	

	&:before{
		content: "";
		width: 100%;
		height: 100%;
		position: absolute;
		top: ${margin(SIZE.small,{multiplier:-1})};
		left: ${margin(SIZE.small,{multiplier:-1})};
		background-color: ${props => props.theme.shadow};

		${mediaQuery[SIZE.medium]}{
			top: ${unit(-8)};
			left: ${margin(SIZE.medium,{multiplier:-1})};
		}

		${mediaQuery[SIZE.large]}{
			top: ${spacer(-2)};
			left: ${margin(SIZE.large,{multiplier:-1})};
		}

		${mediaQuery[SIZE.max]}{
			left: ${margin(SIZE.large,{multiplier:-1})};
		}
	}

`

export const ImageContainer = styled.div`
	${props => column({medium:{span:6}},{direction:props.theme.direction})}
	padding-top: ${margin(SIZE.small)};

	${mediaQuery[SIZE.medium]}{
		padding-top: 0;
	}
`

export const Chapter = styled.div`
	${row({medium:true})}
	padding-bottom: ${spacer(1)};

	${mediaQuery[SIZE.medium]}{
		padding-top: ${unit(8)};
		padding-bottom: ${unit(12)};
	}

	${mediaQuery[SIZE.large]}{
		padding-top: ${spacer(2)};
		padding-bottom: ${spacer(3)};
	}

	&:nth-child(odd){
		${row({medium:{reverse:true}})}

		${ImageContainer}{
			${props => column({medium:{span:8,reverse:true}},{direction:props.theme.direction})}

			${ImageContent}{
				&:before{
					

					${mediaQuery[SIZE.medium]}{
						left: auto;
						right: ${margin(SIZE.medium,{multiplier:-1})};
					}

					${mediaQuery[SIZE.large]}{
						right: ${margin(SIZE.large,{multiplier:-1})};
					}

					${mediaQuery[SIZE.max]}{
						right: ${margin(SIZE.max,{multiplier:-1})};
					}
				}
			}
		}

		${TextContainer}{
			${props => column({medium:{span:4,before:0,after:0}},{direction:props.theme.direction})}
		}
	}

	&:last-child{	
		padding-bottom: 0;
	}
	
`

export const Image = styled.img`
	display: block;
	
`

export const Links = styled(StyledLinks)`
	margin-top: ${spacer(2)};
`